export default {"src":"/_next/static/image/public/img/idea-or-innovation.4bf6f202279802517d8c7ca17784daab.svg","height":192,"width":192};